import { api } from 'api';
import SendIcon from 'assets/ver2/icons/send-outline-icon.svg';
import ShareIcon from 'assets/ver2/icons/share-icon.svg';
import { LogUtil } from 'components/common/LogUtil';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { handleMobileDeviceShare } from 'components/common/func';
import { TRANSACTIONS_PREFIX, TRANSACTION_ADD_PREFIX } from 'constants';
import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { fetchReferralLink } from '../func';
import FormInputCopy from '../modals/ReferralAFiendChooseToShareModal/FormInputCopy';
import FormProgressBar from '../modals/ReferralAFiendChooseToShareModal/FormProgressBar';

const LOG = 'referral';

const useReferral = () => {
  const { t } = useLang();
  let {
    currentUser,
    referralParticipants,
    setLoading,
    isTransactionsEmpty,
    isTransactionsCompletedEmpty,
    isAllTransactionsAsCancelled,
    setCurrentUser,
  } = useCommonStore();
  const { showPortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();
  const { token } = useAuth();
  const navigate = useNavigate();

  let { referral } = currentUser || {};
  let { referee, referralURL } = referral || {};
  let { pending, completed } = referralParticipants || {};

  /* isReferrerEligible */
  /* CASE 1: Not join */
  // referee = false;
  // isTransactionsCompletedEmpty = false;
  // referralURL = '';
  /* CASE 2: Joined */
  // referee = false;
  // isTransactionsCompletedEmpty = false;
  // referralURL = 'test';
  /* CASE 3: Referee - Not join */
  // referee = true;
  // isTransactionsCompletedEmpty = false;
  // referralURL = '';
  /* CASE 4: Referee - Joined */
  // referee = true;
  // isTransactionsCompletedEmpty = false;
  // referralURL = 'test';
  /* END */

  /* isReferrerTracking */
  /* CASE 1 */
  // referee = false;
  // isTransactionsCompletedEmpty = false;
  // pending = ['A A', 'B B'];
  /* CASE 2: Referee */
  // referee = true;
  // isTransactionsCompletedEmpty = false;
  // pending = ['A A', 'B B'];
  /* END */

  /* isReferrerReward */
  /* CASE 1 */
  // referee = false;
  // isTransactionsCompletedEmpty = false;
  // pending = ['A A', 'B B'];
  // completed = ['C C'];
  /* CASE 2: Referee */
  // referee = true;
  // isTransactionsCompletedEmpty = false;
  // pending = ['A A', 'B B'];
  // completed = ['C C'];
  /* END */

  /* isReferrerIneligible */
  /* CASE 1 */
  // referee = false;
  // isTransactionsCompletedEmpty = true;
  /* CASE 2: Referee */
  /* END */

  /* isReferee1st */
  /* CASE 1 */
  // referee = true;
  // isTransactionsEmpty = true;
  /* CASE 2 */
  // referee = true;
  // isAllTransactionsAsCancelled = true;
  /* CASE 3 */
  // referee = true;
  // isTransactionsCompletedEmpty = true;
  /* END */
  const isPendingListEmpty = isEmpty(pending);
  const isCompletedListEmpty = isEmpty(completed);

  const isReferee = Boolean(referee);
  const isReferee1st =
    Boolean(referee) &&
    Boolean(
      isTransactionsEmpty ||
        isAllTransactionsAsCancelled ||
        isTransactionsCompletedEmpty
    );
  const isReferrerEligible = Boolean(
    !isTransactionsEmpty &&
      !isAllTransactionsAsCancelled &&
      !isTransactionsCompletedEmpty &&
      (!referralURL || (isPendingListEmpty && isCompletedListEmpty))
  );
  const isReferrerTracking = Boolean(
    !isTransactionsEmpty &&
      !isAllTransactionsAsCancelled &&
      isCompletedListEmpty &&
      !isPendingListEmpty
  );
  const isReferrerReward = Boolean(
    !isTransactionsEmpty &&
      !isAllTransactionsAsCancelled &&
      !isCompletedListEmpty
  );
  const isReferrerIneligible = Boolean(
    !isReferee &&
      (isTransactionsEmpty ||
        isAllTransactionsAsCancelled ||
        isTransactionsCompletedEmpty)
  );

  LogUtil.log(LOG, `isReferee1st:::${isReferee1st}`);
  LogUtil.log(LOG, `isReferrerEligible:::${isReferrerEligible}`);
  LogUtil.log(LOG, `isReferrerTracking:::${isReferrerTracking}`);
  LogUtil.log(LOG, `isReferrerReward:::${isReferrerReward}`);
  LogUtil.log(LOG, `isReferrerIneligible:::${isReferrerIneligible}`);

  const handleOnShowSharePopup = (referralURL) => {
    if (referralURL) {
      if (isDesktop) {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.REFERRAL_A_FRIEND_CHOOSE_TO_SHARE_MODAL,
          content: referralURL,
        });
      } else {
        handleMobileDeviceShare(referralURL);
      }
    }
  };
  const handleOnShare = async () => {
    if (isReferee1st) {
      if (isTransactionsEmpty || isAllTransactionsAsCancelled) {
        navigate(TRANSACTION_ADD_PREFIX);
        return;
      }
      if (isTransactionsCompletedEmpty) {
        navigate(TRANSACTIONS_PREFIX);
        return;
      }
    }
    if (isReferrerIneligible) {
      navigate(TRANSACTION_ADD_PREFIX);
      return;
    }
    if (!referralURL) {
      setLoading(true);
      referralURL = await fetchReferralLink(token);
      if (referralURL) {
        const { data } = await api.getProfile(token);
        if (data) {
          const authUser = {
            ...data,
            token,
          };
          setCurrentUser(authUser);
          handleOnShowSharePopup(referralURL);
        }
      }
      setLoading(false);
      return;
    }
    handleOnShowSharePopup(referralURL);
  };

  const getFormShareTitle = () => {
    if (isReferee1st) return t('label_referral_description_2');
    if (
      isReferrerReward ||
      isReferrerEligible ||
      isReferrerTracking ||
      isReferrerIneligible
    )
      return t('label_referral_description_1');
    return '';
  };
  const getFormShareDesc = () => {
    if (isReferee1st) return t('label_referral_description_text_4');
    if (isReferrerEligible) return t('label_referral_description_text_1');
    if (isReferrerReward || isReferrerTracking)
      return t('label_referral_description_text_1');
    if (isReferrerIneligible) return t('label_referral_description_text_2');
    return '';
  };
  const getFormShareDesc2 = () => {
    if (isReferrerEligible && !referralURL)
      return t('label_referral_description_text_3');
    if (isReferrerIneligible) {
      return t('label_referral_description_text_5');
    }
    return '';
  };

  const getLabelOfShareButton = () => {
    if (isReferee1st) {
      if (isTransactionsEmpty || isAllTransactionsAsCancelled)
        return t('button_send_money_now');
      if (isTransactionsCompletedEmpty)
        return t('transactions_view_all_transactions');
    }
    if (isReferrerEligible || isReferrerTracking || isReferrerReward)
      return t('button_share');
    if (isReferrerIneligible) return t('button_send_money_now');
    return '';
  };
  const getSendIcon = () => {
    if (isReferee1st) {
      if (isTransactionsEmpty || isAllTransactionsAsCancelled) return SendIcon;
      if (isTransactionsCompletedEmpty) return null;
    }
    if (isReferrerEligible || isReferrerReward || isReferrerTracking)
      return ShareIcon;
    if (isReferrerIneligible) return SendIcon;
    return null;
  };

  const renderFormInputCopy = (props) => {
    const { isHideFormLabel, styles = {} } = props || {};
    if (!referralURL) return null;
    if (isReferrerEligible || isReferrerTracking || isReferrerReward)
      return (
        <FormInputCopy
          value={referralURL}
          isHideFormLabel={isHideFormLabel}
          styles={styles}
        />
      );
    return null;
  };

  const renderFormProgressBar = (props) => {
    const { styles = {} } = props || {};
    if (isReferee1st) {
      if (isTransactionsEmpty || isAllTransactionsAsCancelled) return null;
      if (isTransactionsCompletedEmpty)
        return <FormProgressBar styles={styles} />;
    }
    return null;
  };

  return {
    isReferrerEligible,
    isReferrerTracking,
    isReferrerReward,
    isReferrerIneligible,
    isReferee1st,
    formShareTitle: getFormShareTitle(),
    formShareDesc: getFormShareDesc(),
    formShareDesc2: getFormShareDesc2(),
    labelOfShareButton: getLabelOfShareButton(),
    SendIcon: getSendIcon(),
    handleOnShare,
    FormInputCopy: (props) => renderFormInputCopy(props),
    FormProgressBar: (props) => renderFormProgressBar(props),
    pendingTrackingList: pending,
    completedTrackingList: completed,
  };
};

export default useReferral;
